import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import { useSwr } from "hooks/useSwr";
import { OptionDetail } from "pages/OptionDetail/constants";

const useFindOption = (
  optionId?: string
): {
  option: OptionDetail;
  error: Error;
  mutate: KeyedMutator<OptionDetail>;
} => {
  const { data, error, mutate } = useSwr<OptionDetail>(optionId ? `${API_URL}/option/${optionId}` : null, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return { option: data, error, mutate };
};

export default useFindOption;
